// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'disc-stack';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.563 3.938c0 .895.888 1.754 2.47 2.387 1.583.633 3.73.988 5.967.988 2.238 0 4.384-.355 5.966-.988 1.583-.633 2.472-1.492 2.472-2.387s-.89-1.753-2.472-2.386C13.384.919 11.238.563 9 .563s-4.384.356-5.966.989C1.45 2.185.562 3.043.562 3.938z' />
    <path d='M.563 3.938V9c0 1.864 3.777 3.375 8.437 3.375 4.66 0 8.438-1.51 8.438-3.375V3.938' />
    <path d='M.563 9v5.063c0 1.863 3.777 3.374 8.437 3.374 4.66 0 8.438-1.51 8.438-3.375V9' />
  </g>
);

export const viewBox = '0 0 18 18';
